<template>
    <div class="container">
        <div class="headline">
            <div class="left-container">
                <div @click="backSelect">
                    <img src="@assets/img/anchor/back.png" alt="">
                    <span>返回</span>
                </div>
                <p>虚拟主播合成</p>
            </div>
            <div v-if="stepNum > 0" class="center-container">
                <div class="step">
                    <i :class="{on: stepNum == 1}">1</i>
                    <span :class="{on: stepNum == 1}">内容编辑</span>
                </div>
                <div class="line"></div>
                <div class="step">
                    <i :class="{on: stepNum == 2}">2</i>
                    <span :class="{on: stepNum == 2}">主播编辑</span>
                </div>
                <div class="line"></div>
                <div class="step">
                    <i :class="{on: stepNum == 3}">3</i>
                    <span :class="{on: stepNum == 3}">提交合成</span>
                </div>
            </div>
            <div class="right-container">
                <p @click="pendingNext ? '' : checkListen()" v-if="showMain && stepNum != 3" :class="{submitBtn: true, grey: pendingNext}">下一步</p>
            </div>
        </div>
        <div v-if="!showMain && !showSetting" class="selectPage-container">
            <p>请选择虚拟主播</p>
            <ul>
                <li @click="getAnchorDetail(item.id);getAnchorEmoji(item.id);getAnchorId(item.id);stepNum = 1;showMain = true;showSelect = true;" v-for="(item,index) in characterList" :key="index">
                    <div :style="'background-image: url('+item.cover+')'"></div>
                    <span>{{item.title}}</span>
                </li>
                <li v-if="characterList.length < 2" class="un">
                    <div></div>
                    <span>敬请期待</span>
                </li>
            </ul>
        </div>

        <div v-show="showMain && stepNum == 1" :style="'font-size:'+fontSize+'px'" class="stepOne">
            <div v-if="showSelect" class="mediaType-select">
                <ul>
                    <li @click="showWrite = true;showSelect = false;">
                        <i class="compose"></i>
                        <span>文稿合成音频</span>
                    </li>
                    <li @click="showUploadFile = true;showSelect = false;showUploadSuccess = false;showProgress = false;">
                        <i class="upload"></i>
                        <span>上传音频</span>
                    </li>
                </ul>
            </div>

            <div v-show="showUploadFile" class="upload-container">
                <div v-show="!showProgress&&!showUploadSuccess" id="dragArea" class="upload">
                    <img src="../../assets/img/anchor/file.png" alt="">
                    <p>将文件拖到此处，或<span style="display: inline-block;" id="httpUpBtn">点击上传</span></p>
                </div>

                <div v-show="!showProgress&&!showUploadSuccess" class="notice">
                    <img src="../../assets/img/anchor/noticeIcon.png" alt="">
                    <span>只能上传wav、flac、opus、m4a、mp3文件</span>
                </div>
                
                <div v-show="showProgress" class="progress">
                    <el-progress :width="1.2*fontSize" type="circle" color="#41B48C" :percentage="uploadInfo.progress"></el-progress>
                    <p>{{uploadInfo.name}}</p>
                    <div @click="delUpload" class="btn"><span>取消上传</span></div>
                </div>

                <div v-show="showUploadSuccess&&!showProgress" class="uploadSuccess">
                    <img src="../../assets/img/anchor/cloud.png" alt="">
                    <p class="title">{{uploadInfo.name}}</p>
                    <p class="success">上传成功</p>
                    <div class="btns">
                        <p @click="file.list = [];showUploadSuccess = false;pendingNext = true">
                            <span>删除</span>
                        </p>
                        <p @click="file.list = [];clickUploadBtn();" class="green">
                            <span>替换</span>
                        </p>
                    </div>
                </div>
                
            </div>

            <div v-show="showWrite" class="write-container">
                <div class="anchor-list">
                    <div class="content">
                        <img :src="voiceSex" alt="">
                        <p @click="playPreviewVoice">{{voiceName}}</p>
                        <span @click="playPreviewVoice">（{{voiceLanguage}}）</span>
                    </div>
                    <div @click="showVoice = true" class="btn">
                        <i></i>
                        <span>替换</span>
                    </div>
                </div>

                <div class="btn-container">
                    <div class="left-container">
                        <div class="speed">
                            <p>朗读速度: </p>
                            <div class="speedList">
                                <div @click="showSpeed = !showSpeed" class="speedInput">
                                    <span>{{speed}}</span>
                                    <img :class="{rotate: showSpeed}" src="@assets/img/common/down.png" alt="">
                                </div>
                                <ul v-if="showSpeed" v-click-outside="closeSpeed">
                                    <li @click="speed = item.name;speedIndex = index;showSpeed = false" v-for="(item,index) in speedList" :key="index">{{item.name}}</li>
                                </ul>
                            </div>
                            <!-- <p>秒</p> -->
                        </div>

                        <div class="btnList">
                            <div class="insertStop">
                                <div :class="{on: showStop}" @click="showStop = !showStop">插入停顿</div>
                                <ul v-if="showStop" v-click-outside="closeStop">
                                    <li @click="stop = item.pause;setPause()" v-for="(item,index) in stopList" :key="index">{{item.name}}</li>
                                </ul>
                            </div>
                            <div class="insertWord">
                                <div :class="{on: showWord}" @click="insertSpell()">插入多音字</div>
                            </div>
                            <div class="insertNum">
                                <div :class="{on: showNum}" @click="insertNum()">标注数值</div>
                                <ul v-if="showNum" v-click-outside="closeNum">
                                    <li @click="num = item.num;setNum()" v-for="(item,index) in numList" :key="index">{{item.name}}</li>
                                </ul>
                            </div>
                            <div class="help">
                                <i></i>
                                <div class="content">
                                    <img src="@assets/img/anchor/trangle.png" alt="">
                                    <span>eg:2008</span>
                                    <span>【数值】二千零八，【数字】二零零八</span>
                                </div>
                            </div>
                            <!-- <div class="line"></div>
                            <div class="insertNum">
                                <div :class="{on: showEmoji}" @click="showEmoji = !showEmoji">插入动作</div>
                                <div v-if="showEmoji" @mousewheel="Wheel" @DOMMouseScroll="FireWheel" v-click-outside="closeEmoji" :class="{'emoji-container': true,right: posRight}">
                                    <ul>
                                        <li @mouseenter="bgToGif(index)" @mouseleave="gifToBg(index)" v-for="(item,index) in emojiList" :key="index" @click="setEmoji(item.value,index)">
                                            <div :style="'background-image: url('+item.showBg+')'" class="bg"></div>
                                            <div class="notice">
                                                <img src="@assets/img/anchor/trangle.png" alt="">
                                                <span>{{item.title}}</span>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="point">
                                        <p :data-index="index" v-for="index of emojiPage.page_count" @click="emojiIndex = index;getAnchorEmoji(anchorId)" :key="index" :class="{on: emojiIndex == index}"></p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div class="right-container">
                        <i></i>
                        <div class="content">
                            <img src="@assets/img/anchor/trangle.png" alt="">
                            <span>请选中文字后插入多音字或标注数值</span>
                        </div>
                    </div>
                </div>
                <div ref="content" class="writeContent" maxlength="1500" contenteditable="true"></div>
                <div ref="filterContent" class="filterContent" contenteditable="true"></div>
                <div class="wordNum">您还可以输入{{wordNum}}字</div>
                <div @click="filterContentFocus" v-if="showPlaceHolder" class="placeholder">请输入文本内容</div>
            </div>
        </div>

        <div v-if="showSetting" class="setting-container">
            <div v-if="!showSuccess" class="setting">
                <div class="left-container">
                    <div :style="'background-image: url('+bgUrl+')'" class="bg">
                        <div :style="'background-image: url('+characterUrl+');background-position: '+characterPos+';background-size: '+characterSize+';'" class="character"></div>
                    </div>
                    <div class="line">
                        <p>视频预览</p>
                        <p></p>
                    </div>
                </div>
                <div class="right-container">
                    <ul>
                        <li>
                            <p>素材标题</p>
                            <div class="title">
                                <input maxlength="40" v-model="titleInput" type="text">
                                <p>{{titleInput.length}}/40</p>
                            </div>
                        </li>
                        <li>
                            <p>开头延时</p>
                            <div class="time">
                                <div>
                                    <input v-model="beginInput" type="text">
                                    <div>
                                        <i @click="beginUp" class="up"></i>
                                        <i @click="beginDown" class="down"></i>
                                    </div>
                                </div>
                                <p>秒</p>
                            </div>
                        </li>
                        <li>
                            <p>结尾延时</p>
                            <div class="time">
                                <div>
                                    <input v-model="overInput" type="text">
                                    <div>
                                        <i @click="overUp" class="up"></i>
                                        <i @click="overDown" class="down"></i>
                                    </div>
                                </div>
                                <p>秒</p>
                            </div>
                        </li>
                        <li>
                            <p>输出设置</p>
                            <ul>
                                <li @click="hdIndex = index" :class="{on: hdIndex === index}" v-for="(item,index) in hdList" :key="index">{{item}}</li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-if="!showSuccess" class="btn-container">
                <p @click="backSelect">取 消</p>
                <p @click="anchorSubmit" class="on">确定合成</p>
            </div>
            <div v-if="showSuccess" class="success-container">
                <img src="@assets/img/anchor/success.png" alt="">
                <p>已进入制作流程</p>
                <span>
                    请在屏幕右上角<i></i>消息任务列表中查看制作进度
                </span>
                <div class="btn">
                    <p @click="backIndex">返回首页</p>
                    <p @click="backSelect" class="on">继续制作</p>
                </div>
            </div>
        </div>
        <div v-show="showMain && stepNum == 2" class="content-container">
            <audio ref="previewAudio" src=""></audio>
            <audio ref="previewAudio1" src=""></audio>
            <div class="left-container">
                <div  :style="'background-image: url('+bgUrl+')'" class="video-container">
                    <div :style="'background-image: url('+characterUrl+');background-position: '+characterPos+';background-size: '+characterSize+';'" class="character"></div>
                    <div class="maskpos">视频预览</div>
                </div>
                <div class="select-container">
                    <ul>
                        <li class="list">
                            <img src="@assets/img/anchor/pos.png" alt="">
                            <span>位置选择</span>
                            <ul>
                                <li @click="posIndex = index" v-for="(item,index) in posList" :key="index" :class="{on: posIndex === index}">{{item}}</li>
                            </ul>
                        </li>
                        <li class="list">
                            <img src="@assets/img/anchor/camera.png" alt="">
                            <span>镜头选择</span>
                            <ul>
                                <li @click="changeCameraIndex(index)" v-for="(item,index) in cameraList" :key="index" :class="{on: cameraIndex === index}">{{item}}</li>
                            </ul>
                        </li>
                        <li class="bg">
                            <img src="@assets/img/anchor/bg.png" alt="">
                            <span>背景选择</span>
                            <div @mouseleave="showUpload = false" class="bgList">
                                <!-- <img src="" alt=""> -->
                                <div class="img" :style="'background-image: url('+bgUrl+')'"></div>
                                <div class="change">
                                    <p @click="showUpload = true" class="btn">
                                        更换
                                    </p>
                                    <ul v-show="showUpload" class="list">
                                        <li id="picBtn">本地上传</li>
                                        <!-- <li @click="showMaterialListBox">素材库</li> -->
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="right-container">
                <div class="btn-container">
                    <div class="left-container">
                        <div class="anchorInfo">
                            <img :src="voiceSex" alt="">
                            <p v-if="showUploadFile">自定义音色</p>
                            <span v-if="showUploadFile"></span>
                            <p v-if="!showUploadFile" @click="playPreviewVoice">{{voiceName}}</p>
                            <span v-if="!showUploadFile" @click="playPreviewVoice">（{{voiceLanguage}}）</span>
                        </div>
                        <div class="btnList">
                            <div class="insertNum">
                                <div :class="{on: showEmoji}" @click="showEmoji = !showEmoji">插入动作</div>
                                <div v-if="showEmoji" v-click-outside="closeEmoji" :class="{'emoji-container': true,right: posRight}">
                                    <ul>
                                        <li @mouseenter="bgToGif(index)" @mouseleave="gifToBg(index)" v-for="(item,index) in emojiList" :key="index" @click="setEmoji(item,index)">
                                            <div :style="'background-image: url('+item.showBg+')'" class="bg"></div>
                                            <div class="notice">
                                                <img src="@assets/img/anchor/trangle.png" alt="">
                                                <span>{{item.title}}</span>
                                            </div>
                                            <p :title="item.title">{{item.title}}</p>
                                        </li>
                                    </ul>
                                    <!-- <div class="point">
                                        <p :data-index="index" v-for="index of emojiPage.page_count" @click="emojiIndex = index;getAnchorEmoji(anchorId)" :key="index" :class="{on: emojiIndex == index}"></p>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right-container">
                        <div class="wordNotice">
                            <p>以下文字为AI识别，文字对错将不影响视频</p>
                            <div>
                                <i></i>
                                <div>
                                    <p>请在文字前添加标注<span></span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div ref="content3" id="emojiContent" class="content" contenteditable="true"></div>
                <!-- <div v-if="showPlaceHolder" class="placeholder">请输入文本内容</div> -->
                <div class="audio-container">
                    <div v-if="!isPlay&&!loading" @click="checkSrc" class="playBtn">
                        <img src="@assets/img/anchor/arrow.png" alt="">
                        <span>试听</span>
                    </div>
                    <div v-if="isPlay" @click="pause();isPlay=!isPlay" class="pauseBtn">
                        <img src="@assets/img/anchor/pause.png" alt="">
                        <span>暂停</span>
                    </div>
                    <div v-if="loading" class="loadBtn">
                        <img src="@assets/img/anchor/reload.png" alt="">
                        <span>加载中...</span>
                    </div>
                    <div class="progress-container">
                        <div @click="clickJump($event)" ref="progress" class="progress">
                            <div ref="line" :style="'width: '+audioPercent" class="progressOn"></div>
                        </div>
                        <div class="timeLine">
                           <span>{{currentTime}}</span> / {{duration}}
                        </div>
                    </div>
                    <i class="notice"></i>
                    <div class="content">
                        <img src="@assets/img/anchor/trangle.png" alt="">
                        <span>试听中无法编辑文字</span>
                    </div>
                </div>
                <!-- <div v-if="showWord" class="wordInput-container">
                    <p>多音字</p>
                    <div class="input">
                        <input v-model="spellInput" placeholder="请输入拼音" type="text">
                        <div class="sb">
                            <p @click="showSb=!showSb">
                                <span>{{sb}}</span>
                                <img  :class="{rotate: showSb}" src="@assets/img/anchor/downArrow.png" alt="">
                            </p>
                            <ul v-click-outside="closeSb" v-if="showSb">
                                <li @click="sb = item;showSb=false" v-for="(item,index) in sbList" :key="index">{{item}}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="btn">
                        <p @click="showWord = false">取 消</p>
                        <p @click="spellConfirm" class="on">确 认</p>
                    </div>
                </div> -->
            </div>
        </div>
        <div v-if="showVoice" class="mask"></div>
        <div v-if="showVoice" class="voice-container">
            <p class="title">音色选择</p>
            <div class="tab-container">
                <p v-for="(item, index) in platformVoiceList" :key="item.key" @click="tabIndex = index" :class="{on: tabIndex == index}">{{ item.tab_name }}</p>
            </div>
            <div class="language-container">
                <ul>
                    <li v-for="(item,index) in platformVoiceList[tabIndex].list" :key="index" :class="{on: platformVoiceList[tabIndex].voiceIndex === index}" @click="platformVoiceList[tabIndex].voiceIndex = index;preview(item.preview_url)">
                        <img :src="item.sexSrc" alt="">
                        <p>{{item.name}}（{{item.language}}）</p>
                    </li>
                </ul>
            </div>
            <!-- <div class="language-container">
                <ul>
                    <li v-for="(item,index) in platformVoiceList[tabIndex].list" :key="index" :class="{on: voiceIndex === index}" @click="voiceIndex = index;preview(item.preview_url)">
                        <img :src="item.sexSrc" alt="">
                        <p>{{item.name}}（{{item.language}}）</p>
                    </li>
                </ul>
            </div> -->
            <div class="btn-container">
                <p @click="showVoice = false">取 消</p>
                <p @click="changeVoice();showVoice = false" class="on">确 认</p>
            </div>
        </div>

        <div v-if="showLoading" class="mask-container">
            <div class="loading-container">
                <i class="loadIcon"></i>
                <p>配音合成中，请稍等片刻</p>
                <span>文字/音频越长等待的时间越久哦</span>
                <p @click="showLoading = false; loading = false; stepNum = 1;" class="btn">回到上一步</p>
            </div>
        </div>

        <audio ref="audioDom" src=""></audio>
        
        <div v-if="showWord" class="wordInput-bg">
            <div class="wordInput-container">
                <p>多音字</p>
                <div class="input-container">
                    <div v-for="(item,index) in textArr" :key="index" class="input">
                        <span>{{item.name}}</span>
                        <input style="ime-mode:disabled" @input="item.value=item.value.replace(/[\u0391-\uFFE5]/gi,'')" v-model="item.value" placeholder="请输入拼音" type="text">
                        <div class="sb">
                            <p :class="{on: item.status}" @click="setStatus(index)">
                                <span>{{item.voiceName}}</span>
                                <img  :class="{rotate: item.status}" src="@assets/img/anchor/downArrow.png" alt="">
                            </p>
                            <ul :style="'top:'+top+'px'" v-if="item.status">
                                <li @click="item.voiceName = items;item.status=false" v-for="(items,indexs) in sbList" :key="indexs">{{items}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="btn">
                    <p @click="showWord = false">取 消</p>
                    <p :title="!canConfirm ? '您有拼音尚未输入' : ''" @click="spellConfirm" :class="{on:true,op: !canConfirm}">确 认</p>
                </div>
            </div>
        </div>

        <div v-if="showTips" class="tips-bg">
            <div class="tips-container">
                <img src="../../assets/img/anchor/tips.png" alt="">
                <p>重要提示</p>
                <span>动作间隔太紧，不能添加动作</span>
                <div @click="showTips = false" class="btn"></div>
            </div>
        </div>

        <div v-if="showInputTips" class="tips-bg">
            <div class="tips-container">
                <img src="../../assets/img/anchor/tips.png" alt="">
                <p>重要提示</p>
                <span>请勿编辑文字</span>
                <div @click="freshContent3" class="btn"></div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import vClickOutside from "v-click-outside";
    import common from '@common/common'
    import * as config from '@common/config'
    import store from "@common/store";

    export default {
        directives: {
            clickOutside: vClickOutside.directive
        },
        watch: {
            textArr: {
                deep: true,
                handler: function(n, o) {
                    let length = this.textArr.length;
                    let index = 0;
                    this.textArr.forEach(el => {
                        if(el.value){
                            index ++
                        }
                    })

                    if(index == length){
                        this.canConfirm = true
                    }else{
                        this.canConfirm = false
                    }
                }
            },
            posIndex(to) {
                if(to == 0){
                    this.characterPos = '-1000000px';
                    // this.pendingNext = true;
                }else if(to == 1){
                    this.characterPos = 'left bottom'
                    // this.pendingNext = false;
                }else if(to == 2){
                    this.characterPos = 'center bottom'
                    // this.pendingNext = false;
                }else if(to == 3){
                    this.characterPos = 'right bottom'
                    // this.pendingNext = false;
                }
            },
            cameraIndex(to) {
                if(to == 0){
                    // if(this.posIndex == 0){
                    //     this.characterPos = '-1000000px';
                    // }else if(this.posIndex == 1){
                    //     this.characterPos = 'left 30px'
                    // }else if(this.posIndex == 2){
                    //     this.characterPos = 'center 30px'
                    // }else if(this.posIndex == 3){
                    //     this.characterPos = 'right 30px'
                    // }
                    // this.characterUrl = this.gifUrl
                    // this.characterSize = '283.5px 504px'
                    this.characterUrl = this.detail.half;
                }else if(to == 1){
                    // this.characterUrl = this.gifUrl
                    
                    this.characterUrl = this.detail.twothirds;
                }else if(to == 2){
                    // if(this.posIndex == 0){
                    //     this.characterPos = '-1000000px';
                    // }else if(this.posIndex == 1){
                    //     this.characterPos = 'left bottom'
                    // }else if(this.posIndex == 2){
                    //     this.characterPos = 'center bottom'
                    // }else if(this.posIndex == 3){
                    //     this.characterPos = 'right bottom'
                    // }
                    // this.characterUrl = this.gifUrl
                    // this.characterSize = '141.75px 252px'
                    this.characterUrl = this.detail.full;
                }else if(to == 3){
                    // this.characterUrl = this.gifUrl
                    this.characterUrl = this.detail.close;
                }
            },
            showWrite(to) {
                if(to) {
                    if(this.$refs.content){
                        this.$refs.content.addEventListener('focus', () => {
                            this.showPlaceHolder = false
                        })
                        this.$refs.content.addEventListener('blur', () => {
                            if(!this.$refs.content.innerText){
                                this.showPlaceHolder = true
                            }   
                        })

                        this.$refs.content.addEventListener('paste', (e) => {
                            let ev = e || window.event
                            e.preventDefault();
		                    e.stopPropagation();

                            let length = e.clipboardData.getData('text').length

                            if(this.$refs.content.innerText.length + length <= 1500){
                                this.$refs.content.innerHTML += e.clipboardData.getData('text')
                            }

                            let wordNum = 1500 - this.$refs.content.innerText.length
                            // console.log(wordNum)
                            if(wordNum >= 0){
                                this.wordNum = wordNum
                            }else{
                                this.wordNum = 0
                            }

                            if(wordNum > 0){
                                this.pendingNext = false;
                            }else{
                                this.pendingNext = true;
                            }

                            keepLastIndex(ev.target)

                            function keepLastIndex(obj) {
                                if (window.getSelection) { //ie11 10 9 ff safari
                                    obj.focus(); //解决ff不获取焦点无法定位问题
                                    var range = window.getSelection(); //创建range
                                    range.selectAllChildren(obj); //range 选择obj下所有子内容
                                    range.collapseToEnd(); //光标移至最后
                                } else if (document.selection) { //ie10 9 8 7 6 5
                                    var range = document.selection.createRange(); //创建选择对象
                                    //var range = document.body.createTextRange();
                                    range.moveToElementText(obj); //range定位到obj
                                    range.collapse(false); //光标移至最后
                                    range.select();
                                }
                            }
                            // console.log(e.clipboardData.getData('text'))
                            
                        })

                        this.$refs.content.addEventListener('keydown',e=>{
                            var ev = e || window.event
                            let contentEditOn = document.getElementsByClassName('contentEditOn')
                            let numLength = 0
                            for (let index = 0; index < contentEditOn.length; index++) {
                                const element = contentEditOn[index];
                                numLength += element.innerText.length
                            }
                            // console.log(ev)
                            

                            if (ev.target.innerText.length - numLength > 1500 && ev.keyCode !== 8 && ev.keyCode !== 116) {
                                ev.preventDefault()
                            }
                        })

                        this.$refs.content.addEventListener("keyup",e=>{
                            let labelDom = document.getElementsByTagName('label')
                            console.log(labelDom)
                            if(labelDom){
                                for (let index = 0; index < labelDom.length; index++) {
                                    const element = labelDom[index];
                                    if(element.nextSibling){
                                        if(element.nextSibling.nodeType == 3){
                                            element.classList.remove('on')
                                        }else if(!element.nextSibling.classList.contains('contentEditOn')){
                                            element.classList.remove('on')
                                        }
                                    }else{
                                        console.log(element)
                                        element.classList.remove('on')
                                    }
                                    // console.log(element.nextSibling)
                                }
                            }
                        })

                        this.$refs.content.addEventListener("input", (e) => {
                            
                            let ev = e || window.event
                            let contentEditOn = document.getElementsByClassName('contentEditOn')

                            let numLength = 0
                            for (let index = 0; index < contentEditOn.length; index++) {
                                const element = contentEditOn[index];
                                numLength += element.innerText.length
                            }
                            // console.log(ev)
                            if (ev.target.innerText.length - numLength > 1500 && ev.inputType !== "deleteContentBackward") {
                                setTimeout(() => {
                                    // ev.target.innerText = ev.target.innerText.substring(0, 800)
                                    // ev.target.innerHTML = this.saveInnerHtmlContent
                                    let wordNum = 1500 - e.target.innerText.length + numLength
                                    console.log(wordNum)
                                    if(wordNum >= 0){
                                        this.wordNum = wordNum
                                    }else{
                                        this.wordNum = 0
                                    }
                                    // ev.preventDefault()
                                    keepLastIndex(ev.target)
                                }, 0)
                            }else{
                                this.saveInnerHtmlContent = ev.target.innerHTML
                            }

                            let wordNum = 1500 - e.target.innerText.length + numLength
                            console.log(e.target.innerText.length,wordNum,numLength)
                            if(wordNum >= 0){
                                this.wordNum = wordNum
                            }else{
                                this.wordNum = 0
                            }
                            if(e.target.innerText.length > 0){
                                this.pendingNext = false;
                            }else{
                                this.pendingNext = true;
                            }

                            function keepLastIndex(obj) {
                                if (window.getSelection) { //ie11 10 9 ff safari
                                    obj.focus(); //解决ff不获取焦点无法定位问题
                                    var range = window.getSelection(); //创建range
                                    range.selectAllChildren(obj); //range 选择obj下所有子内容
                                    range.collapseToEnd(); //光标移至最后
                                } else if (document.selection) { //ie10 9 8 7 6 5
                                    var range = document.selection.createRange(); //创建选择对象
                                    //var range = document.body.createTextRange();
                                    range.moveToElementText(obj); //range定位到obj
                                    range.collapse(false); //光标移至最后
                                    range.select();
                                }
                            }
                        });
                    }
                }else{
                    this.$refs.content.removeEventListener('focus', () => {
                        this.showPlaceHolder = false
                    })
                    this.$refs.content.removeEventListener('blur', () => {
                        if(!this.$refs.content.innerText){
                            this.showPlaceHolder = true
                        }   
                    })
                    this.$refs.content.removeEventListener("input", (e) => {
                        console.log(e)
                        if(e.target.innerText.length > 0){
                            this.pendingNext = false;
                        }else{
                            this.pendingNext = true;
                        }
                    });
                }
            },
            showUploadFile(to) {
                if(to){
                    // this.picStream = new Stream(this.picConfig)
                    this.file.stream = new Stream(this.streamConfig);
                    this.$nextTick(() => {
                        let dragArea = document.getElementById('dragArea')
                        let span = dragArea.getElementsByTagName('span')[1]
                        console.log(span)
                        if(span){
                            span.remove()
                        }
                    })
                }else{
                    this.file.stream.destroy()
                    this.picStream.destroy()
                }
            },
            stepNum(to){
                if(to == 2){
                    this.picStream = new Stream(this.picConfig)
                    this.$refs.content3.addEventListener('keydown', (e) => {
                        e.preventDefault();
                    })

                    this.$refs.content3.addEventListener('compositionstart', (e) => {
                        e.preventDefault();
                    })

                    this.$refs.content3.addEventListener('compositionend', (e) => {
                        e.preventDefault();
                    })

                    this.$refs.content3.addEventListener('input', (e) => {

                        // console.log(e)
                        this.$refs.content3.blur()
                        this.showInputTips = true;
                    })
                }else{
                    if(this.picStream){
                        this.picStream.destroy()
                    }
                }
            }
        },
        data() {
            return {
                tab_key: '',
                vid: '',
                platformVoiceList: [],
                tabIndex: 0,
                top: 0,
                canConfirm: false,
                saveStr: '',
                textArr: [],
                saveInnerHtmlContent: '',
                wordNum: 1500,
                saveContent3: '',
                showInputTips: false,
                streamConfig: {},
                picStream: null,
                showTips: false,
                pendingNext: true,
                emojiStatusIndex: 0,
                submitEmojiList: [],
                pickRes: [{bg: 0, word: "测"}, {bg: 298, word: "试"}, {bg: 596, word: "测"}, {bg: 894, word: "试"}],
                file_id: '',
                fileList: [],
                anchor_id: '',
                showUploadSuccess: false,
                showProgress: false,
                uploadInfo: {
                    progress: 0
                },
                fileConfig: {},
                asperaConfig: {},
                showSelect: true,
                showUploadFile: false,
                showWrite: false,
                fontSize: 100,
                stepNum: 0,
                saveContent: '',
                posList: ['无','左边','中间','右边'],
                posIndex: 0,
                cameraList: ['半身','2/3身','全身','特写'],
                cameraIndex: 0,
                showMain: false,
                showVoice: false,
                showUpload: false,
                showSpeed: false,
                showStop: false,
                showWord: false,
                showNum: false,
                showEmoji: false,
                showSb: false,
                showPlaceHolder: true,
                showSetting: false,
                showSuccess: false,
                loading: false,
                isPlay: false,
                posRight: false,
                showLoading: false,
                characterList: [
                    {
                        img: '',
                        name: ''
                    }
                ],
                speedList: [
                    {name: '1.5', spd: '+500'},
                    {name: '1.2', spd: '+200'},
                    {name: '1.0', spd: '0'},
                    {name: '0.8', spd: '-200'},
                    {name: '0.5', spd: '-500'}
                ],
                speed: '1.0',
                speedIndex: 2,
                stopList: [
                    {name: '0.1秒', pause: 'p100'},
                    {name: '0.2秒', pause: 'p200'},
                    {name: '0.4秒', pause: 'p400'},
                    {name: '0.6秒', pause: 'p600'},
                    {name: '1.0秒', pause: 'p1000'}
                ],
                stop: '',
                numList: [
                    {name: '数值', num: 'cardinal'},
                    {name: '数字', num: 'digits'}
                ],
                num: '',
                emojiList: [],
                emojiPage: {},
                emojiIndex: 1,
                sbList: ['第一声','第二声','第三声','第四声'],
                sb: '第一声',
                spellInput: '',
                sel: '',
                range: '', 
                frag: '',
                bgUrl: require('../../assets/img/anchor/previewBg.png'),
                boy: require('../../assets/img/anchor/avatar-b.png'),
                girl: require('../../assets/img/anchor/avatar-g.png'),
                characterUrl: require('../../assets/img/anchor/shen.png'),
                testJson: require('../json.json'),
                // gifUrl: require('../../assets/img/anchor/gif.gif'),
                characterPos: '-1000000px',
                characterSize: '252px 252px',
                picConfig: {
                    browseFileId: 'picBtn',
                    extFilters: ['.jpg', '.png', '.tga', '.jpeg'],
                    maxSize: 20*1024*1024,
                    customered: true,
                    autoUploading: true,
                    multipleFiles: false,
                    retryCount: 3,
                    tokenURL: '',
                    uploadURL: '',
                    postVarsPerFile: {
                        appId: '',
                        appSecret: ''
                    },
                    onComplete: (f) => {
                        this.picStream.cancelOne(f.id);
                        f.targetPath = JSON.parse(f.msg).targetPath;
                        // const path = (JSON.parse(f.msg)).targetPath
                        this.changeBg([f])
                    },
                    onUploadError: (f) => {

                    },
                    onMaxSizeExceed: (f) => {

                    }
                },
                titleInput: '',
                beginInput: 0,
                overInput: 0,
                hdList: ['720P', '1080P'],
                hdIndex: 0,
                voiceList: [],
                voiceIndex: 0,
                saveVoiceIndex: 0,
                // voiceSrc: 'https://aitest.smgtech.net/xnewstest/original/2021/05/19/257win62072ab2c31bd2afbdbd2522ac13cac11621388719444.mp3',
                voiceSrc: '',
                voiceId: '',
                duration: '00:00:00',
                currentTime: '00:00:00',
                audioPercent: '0%',
                detail: {

                },
                previewVoiceSrc: '',
                voiceName: '',
                voiceLanguage: '',
                voiceSex: '',
                anchorId: '',
                wheelInterval: null,
                baseConfig: {
                    customered: true,
                    autoUploading: true,
                    multipleFiles: false,
                    retryCount: 3,
                    tokenURL: "",
                    uploadURL: "",
                    postVarsPerFile: {
                    appId: "",
                    appSecret: ""
                    },
                    onMaxSizeExceed: f => {
                    this.$toast("文件大小超出限制");
                    },
                    onCancel: f => {
                    console.log("cancel", f);
                    },
                    onExtNameMismatch: () => {
                        this.$toast("无法上传不支持的格式");
                        this.showProgress = false;
                        this.showUploadSuccess = false;
                    }
                },
                pic: {
                    // 图片部分数据模型
                    types: [],
                    assets: []
                },
                video: {
                    // 视频部分数据模型
                    types: [],
                    assets: []
                },
                audio: {
                    // 音频部分数据模型
                    types: [],
                    assets: []
                },
                aspera: {
                    // aspera通道上传
                    needInstall: false,
                    files: [],
                    filetypes: [],
                    maxSize: 10 * 1024 * 1024 * 1024,
                    checkInstalled: null,
                    config: {
                    host: "",
                    userName: "",
                    userPassword: "",
                    deviceID: ""
                    },
                    start: f => {
                    console.log("aspera uploading");
                    const current = {
                        remote_host: this.aspera.config.host,
                        remote_user: this.aspera.config.userName,
                        remote_password: common.hex2str(this.aspera.config.userPassword),
                        create_dir: true,
                        direction: "send",
                        needs_destination: "",
                        paths: [
                        {
                            source: f.name,
                            destination: f.serverpath
                        }
                        ]
                    };
                    const params = {
                        allow_dialogs: false
                    };

                    fileControls.asperaWeb.startTransfer(current, params, {
                        error: responseData => {
                        let userMessage = responseData.error.user_message;
                        this.$toast(userMessage);
                        },
                        success: res => {
                        console.log("start", res);
                        }
                    });
                    },
                    complete: f => {
                    f.targetPath = f.serverpath;
                    this.file.list.forEach(i => {
                        if (i.id === f.id) {
                        this.$set(i, "hideasset", true);
                        }
                    });
                    console.log(123123);
                    // this.addAssetsToPage([f])
                    this.addFilePromises.push(this.addAssetsToPage([f]));
                    },
                    delete: f => {
                    // 删除上传过程中的文件
                    if (f.pending) {
                        this.deleteAsset(f.idstring, this.file.list);
                        return;
                    } else {
                        fileControls.asperaWeb.removeTransfer(f.uuid);
                        this.delItem(this.file.list, f.id);
                    }
                    }
                },
                file: {
                    // 文件部分数据模型
                    title: "文件",
                    description: "",
                    stream: null,
                    list: [],
                    cancelOne: f => {
                    if (f.pending) {
                        this.deleteAsset(f.idstring, this.file.list);
                        return;
                    }

                    if (this.file.stream) {
                        try {
                        this.file.stream.cancelOne(f.id);
                        } catch (error) {
                        console.log("stream取消出错", error);
                        }

                        this.delItem(this.file.list, f.id);
                    }
                    },
                    config: {
                    dragAndDropArea: "dragArea",
                    browseFileId: "httpUpBtn",
                    extFilters: ['.wav','.flac','.opus','.m4a','.mp3'],
                    maxSize: 10 * 1024 * 1024 * 1024,
                    onQueueComplete: m => {
                        // this.$toast('所有文件已上传完成')
                        // this.uploading = false
                        // this.passUploading()
                    },
                    onComplete: f => {
                        this.file.stream.cancelOne(f.id);

                        f.targetPath = JSON.parse(f.msg).targetPath;
                        this.file.list.forEach(i => {
                            if (i.id === f.id) {
                                i.targetPath = f.targetPath;
                                this.showProgress = false;
                            }
                        });

                        console.log(this.file.list)
                        this.addAssetsToPage([f])
                    },
                    onUploadError: f => {
                        this.$toast("文件上传出错");
                    },
                    onSelect: f => {
                        console.log(f)
                        this.file.list = []
                        // 视音频数量限制10个（待添加），超出：stream.stop(), stream.cancel()
                        setTimeout(() => {
                            // f.forEach(el => {
                            //     if(this.checkFileType(el)!=3){
                            //         this.file.stream.stop();
                            //         this.file.stream.cancel();
                            //         return;
                            //     }
                            // })

                            // if (!status) {
                            //     this.file.stream.stop();
                            //     this.file.stream.cancel();
                            //     return;
                            // }

                            f = this.filterFiles(f, this.file.config.maxSize);

                            let totalList = this.file.list.concat(f);
                            const allTypes = this.pic.types
                                .concat(this.video.types)
                                .concat(this.audio.types);
                                console.log(allTypes)
                            totalList = totalList.filter(i => allTypes.indexOf(i.ext) > -1);
                            this.file.list = Array.from(new Set(totalList));
                            
                            this.uploadInfo.name = f[0].name;
                            this.uploadInfo.id = f[0].id;
                            // this.$emit('handleStart',f[0].name)
                        }, 0);
                    },
                    onUploadProgress: f => {
                        console.log(f)
                        this.showProgress = true;
                        this.uploadInfo.progress = f.percent;
                        // this.handleProgress(this.file.list, f);
                        // this.$emit('handleProgress',f)
                    }
                    }
                }
            }
        },
        methods: {
            delUpload() {
                // console.log(this.file.list)
                if(this.uploadInfo.id){
                    this.file.stream.cancelOne(this.uploadInfo.id);
                    this.showProgress = false;
                    this.uploadInfo.progress = 0;
                }
            },
            filterContentFocus() {
                this.showPlaceHolder = false;
                this.$nextTick(() => {
                    let writeContent = document.getElementsByClassName('writeContent')[0]
                    writeContent.focus()
                })
                
            },
            freshContent3() {
                this.showInputTips = false;
                this.$refs.content3.innerHTML = this.saveContent3;
                this.setDelClick()
            },
            clickUploadBtn() {
                let httpUpBtn = document.getElementById('httpUpBtn')
                httpUpBtn.click()
            },
            filterFiles(f, size) {
                // 大小超出的文件删除出去
                let files = [];
                files = f.filter(i => {
                    return i.size < size;
                });

                this.file.list.forEach((j, k) => {
                    let idx = files.length - 1;
                    while (idx >= 0) {
                    if (files[idx].name === j.name && !j.pending && !j.hideasset) {
                        this.$toast("请不要同时上传相同的文件");
                        files.splice(idx, 1);
                    }

                    idx -= 1;
                    }
                });

                return files;
            },
            async addAssetsToPage(data) {
                console.log(data)
                let tmpId = this.$route.query.d;

                const filelist = [];
                data.forEach(i => {
                    const type = this.checkFileType(i);
                    // 将文件名改为截取前40位加后缀名
                    const fileName = i.pureName || i.title || i.name || "";
                    const nameParts = fileName.split(".");
                    const ext = nameParts.pop();
                    let nameLeft = nameParts.join(".");
                    nameLeft = nameLeft.substr(0, 40);
                    const filetitle = `${nameLeft}.${ext}`;

                    const file = {
                        type: 3,
                        title: filetitle,
                        path: i.targetPath || i.path
                    };

                    filelist.push(file);
                });

                const info = { file_info: JSON.stringify(filelist) };
                return common.myFetch(config.apis.File_add, info).then(r => {
                    if (r) {
                        console.log(r)
                        this.file_id = r.list[0].file_id;
                        this.showProgress = false;
                        this.showUploadSuccess = true;
                        this.pendingNext = false;
                    }
                });
            },
            checkFileType(f) {
                // 检查文件类型
                let type = "";
                let ext = f.name.split(".").pop() || f.path.split(".").pop();
                ext = ext.toLowerCase();

                if (this.pic.types.indexOf(ext) > -1) {
                    type = 1;
                } else if (this.video.types.indexOf(ext) > -1) {
                    type = 2;
                } else if (this.audio.types.indexOf(ext) > -1) {
                    type = 3;
                }
                return type;
            },
            convertByteToGb(n) {
                // 将字节转换为GB
                return n / 1024 / 1024 / 1024;
            },
            loadConfig() {
                return Promise.all([this.getConfig1(), this.getAsperaConfig1()]);
            },
            getConfig1() {
                return common.getFileConfigs().then(r => {
                    if(r){
                        this.fileConfig = r;
                        return true;
                    }
                });
            },
            getAsperaConfig1() {
                // 获取aspera上传配置
                return common.myFetch(config.apis.File_Aspera).then(r => {
                    if (r) {
                        this.asperaConfig = r;
                        return true;
                    }
                });
            },
            getConfig() {
                if(this.fileConfig){
                    let r = this.fileConfig;
                    this.baseUrl = r.url;
                    this.appId = r.app_id;
                    this.appSecret = r.app_secret;
                    this.cancel_enable = r.cancel_enable;
                    const dataConfig = {
                        tokenURL: this.baseUrl + config.apis.File_get_token,
                        uploadURL: this.baseUrl + config.apis.File_post,
                        postVarsPerFile: {
                            appId: this.appId,
                            appSecret: this.appSecret
                        }
                    };
                    Object.assign(this.picConfig, dataConfig, common.userKeys());
                    Object.assign(this.baseConfig, dataConfig);
                    return true;
                }
            },
            getAsperaConfig() {
                // 获取aspera上传配置
                return new Promise((resolve, reject) => {
                    if(this.asperaConfig){
                        console.log(this.asperaConfig)
                        let r = this.asperaConfig;
                        const types = r.file_format;
                        this.file_format_types = types;
                        if(r.upload_limit_num){
                            this.upload_limit_num = Number(r.upload_limit_num)
                        }
                        this.pic.types = types.image;
                        this.video.types = types.video;
                        this.audio.types = types.audio;
                        // window._XN_upVdoTps = types.video // 视频格式前缀为source，此处为传入streamjs
                        this.aspera.config = r.upload_config;
                        // const filetypes = types.image.concat(types.video).concat(types.audio);
                        const filetypes = types.video;
                        this.aspera.filetypes = filetypes;
                        const extFilters = filetypes.map(f => `.${f}`);
                        // this.file.config.extFilters = extFilters;

                        this.file.config.maxSize =
                            r.file_format.file_size || this.file.config.maxSize;
                        this.aspera.maxSize = r.file_format.file_size || this.aspera.maxSize;

                        this.file.description = `素材格式：${filetypes.join(
                            ","
                        )} <br><br> 视频、音频每种素材不超过10个，单个素材不超过${this.convertByteToGb(
                            this.aspera.maxSize
                        )}GB`;

                        window._XN_upCfg = {
                            asperaPath: r.aspera_path,
                            httpPath: r.original_path,
                            fileNameId: r.filename_id
                        };
                        resolve(true)
                    }else{
                        reject(false)
                    }
                })
            },
            async load() {
                // 加载js文件
                // return common.load(config.streamjs)
                return this.getAsperaConfig().then(() => {
                    return Promise.all([this.loadjs(), this.getConfig()]);
                });
            },
            loadjs() {
                // 加载js文件
                if (window.Stream) {
                    return new Promise((r, j) => {
                    r(true);
                    });
                }

                return common.load(config.streamjs);
            },
            setConfig() {
                this.load().then(() => {
                    console.log(87665)
                    this.configFile();
                });
            },
            async configFile() {
                // 配置文件
                const config = Object.assign({}, this.baseConfig, this.file.config, common.userKeys());
                console.log(config)
                this.streamConfig = config;
                // this.file.stream = new Stream(config);
                // this.picStream = new Stream(this.picConfig)
                
            },
            preview(src) {
                this.$refs.previewAudio1.src = src
                this.$refs.previewAudio1.load()
                this.$refs.previewAudio1.play()
            },
            changeCameraIndex(index) {
                if(this.posIndex == 0){
                    this.$toast('请先选择主播位置')
                }else{
                    this.cameraIndex = index
                }
            },
            playPreviewVoice() {
                this.$refs.previewAudio.play()
            },
            Wheel(e) {
                // console.log(e.wheelDelta)
                if(this.wheelInterval){
                    clearTimeout(this.wheelInterval)
                    this.wheelInterval = null;
                }

                this.wheelInterval = setTimeout(() => {
                    if(e.wheelDelta < 0){
                        if(this.emojiIndex < this.emojiPage.page_count){
                            this.emojiIndex ++
                            this.getAnchorEmoji(this.anchorId)
                        }
                    }else{
                        if(this.emojiIndex > 1){
                            this.emojiIndex --
                            this.getAnchorEmoji(this.anchorId)
                        }
                    }
                }, 300);
            },
            FireWheel(e) {
                // console.log(e.detail)
                if(this.wheelInterval){
                    clearTimeout(this.wheelInterval)
                    this.wheelInterval = null;
                }

                this.wheelInterval = setTimeout(() => {
                    console.log(e.detail)
                    if(e.detail < 0){
                        if(this.emojiIndex > 1){
                            this.emojiIndex --
                            this.getAnchorEmoji(this.anchorId)
                        }
                    }else{
                        if(this.emojiIndex < this.emojiPage.page_count){
                            this.emojiIndex ++
                            this.getAnchorEmoji(this.anchorId)
                        }
                    }
                }, 300);
            },
            getAnchorId(id) {
                const info = {
                    anchor_id: id
                }

                common.myFetch(config.apis.anchorCreate, info)
                .then((r) => {
                    if (r) {
                        console.log(r)
                        this.anchor_id = r.id
                    }
                })
            },
            checkListen() {
                // if(this.voiceId && this.saveContent == this.$refs.content.innerText && this.saveVoiceIndex == this.voiceIndex){
                //     this.showMain = false;
                //     this.showSetting = true
                // }else{
                //     this.$toast('请先试听')
                // }
                // console.log(this.fileList)
                this.anchorSubmit()
            },
            afterinsert(newElement,targetElement){
                var parent = targetElement.parentNode;
                if (parent.lastChild === targetElement) {
                    parent.appendChild(newElement);
                }else{
                    parent.insertBefore(newElement,targetElement.previousSibling);
                }
            
            },
            getInnerText() {
                this.$refs.filterContent.innerHTML = this.$refs.content.innerHTML;
                let contentEditOnSpan = document.querySelectorAll('.filterContent .contentEditOn')
                if(contentEditOnSpan){
                    for (let index = 0; index < contentEditOnSpan.length; index++) {
                        const element = contentEditOnSpan[index];
                        let name = element.getAttribute('data-name')

                        if(name == 'say-as' || name == 'phoneme'){
                            if(element.previousSibling && element.previousSibling.nodeType){
                                if(element.previousSibling.nodeName == 'LABEL'){
                                    element.innerText = element.previousSibling.innerText
                                    element.previousSibling.remove()
                                }
                            }
                        }else{
                            if(element.parentNode){
                                if(element.parentNode.nodeName == 'LABEL'){
                                    let u = element
                                    this.afterinsert(u,element.parentNode)
                                    // element.remove()
                                }
                            }
                        }
                        // console.log(name)
                    }
                    // console.log(contentEditOnSpan)
                }
                // console.log(this.$refs.filterContent.innerHTML)
                // let contentEditOnSpan = document.querySelectorAll('.filterContent .contentEditOnContainer')
                // if(contentEditOnSpan){
                //     for (let index = 0; index < contentEditOnSpan.length; index++) {
                //         const element = contentEditOnSpan[index];
                //         let contentEditOnSpan1 = element.querySelector('.contentEditOn')
                //         console.log(contentEditOnSpan1)
                //     }
                // }
                // this.$refs.filterContent.innerHTML = this.$refs.content.innerHTML;
                // let contentEditOnSpan = document.querySelectorAll('.filterContent .contentEditOn')
                // if(contentEditOnSpan){
                //     console.log(contentEditOnSpan)
                //     for (let index = 0; index < contentEditOnSpan.length; index++) {
                //         const element = contentEditOnSpan[index];
                //         element.innerHTML = element.dataset.name
                //     }
                // }

                let nullSpan = document.querySelectorAll('.filterContent span')

                if(nullSpan){
                    for (let index = 0; index < nullSpan.length; index++) {
                        const element = nullSpan[index];
                        // console.log(element)
                        if(!element.getAttribute('class') && element.innerText == ''){
                            element.remove()
                        }
                    }
                }

                return this.$refs.filterContent.innerHTML
                // console.log(this.$refs.filterContent.innerText)
            },
            async anchorSubmit() {
                let type = ''
                let content = ''
                let title = ''
                let spd = ''
                let actions = []
                let status = true
                if(this.stepNum == 1){
                    if(this.showWrite){
                        type = 'makeup'
                        // content = this.$refs.content.innerText
                        content = await this.getInnerText()
                        console.log(content)
                        title = 'HC'+Date.parse(new Date())
                        spd = this.speedList[this.speedIndex].spd
                    }else if(this.showUploadFile){
                        type = 'file'
                    }
                }else if(this.stepNum == 2){
                    if(this.posIndex == 0){
                        let config = {
                            title: '温馨提示',
                            content: '您尚未选择主播位置，是否继续？',
                            btn1: '确定',
                            btn2: '取消',
                            showIcon: false
                        }

                        status = await this.$MediaPlatformNotify(config)
                        console.log(status)
                    }

                    type = 'action'
                    if(this.submitEmojiList.length > 0){
                        this.submitEmojiList.forEach(el => {
                            actions.push({
                                start: el.bg,
                                key: el.id
                            })
                        })
                    }
                    actions = JSON.stringify(actions)
                }else if(this.stepNum == 3){
                    type = 'final'
                }
                // return false;
                // console.log(this.file_id)
                if(!status) return

                // return

                const info = {
                    actions: actions,
                    type: type,
                    audio_title: title,
                    content: content,
                    vid: this.vid,
                    tab_key: this.tab_key,
                    spd: spd,
                    id: this.anchor_id,
                    file_id: this.file_id,
                    title: this.titleInput,
                    start_delay: this.beginInput,
                    end_delay: this.overInput,
                    resolution: this.hdIndex,
                    // file_id: this.voiceId,
                    anchor_id: this.anchorId,
                    location: this.posIndex,
                    camera: this.cameraIndex,
                    background_url: this.bgUrl
                }

                common.myFetch(config.apis.anchorSubmit, info)
                .then((r) => {
                    if (r) {
                        console.log(r)
                        if(this.stepNum == 1){
                            this.loading = true;
                            this.showLoading = true;
                            this.submitEmojiList = []
                            // this.pendingNext = true;
                            this.stepNum = 2;
                            this.$refs.content3.innerHTML = ''
                        }else if(this.stepNum == 2){
                            // this.currentTime = '00:00:00'
                            // this.duration = '00:00:00'
                            // this.voiceSrc = ''
                            // this.voiceId = ''
                            // this.audioPercent = '0%'
                            // this.$refs.audioDom.src =  ''
                            // this.$refs.audioDom.load()
                            if(this.$refs.audioDom){
                                this.$refs.audioDom.pause()
                            }
                            this.showSetting = true;
                            this.stepNum = 3;
                        }else{
                            this.currentTime = '00:00:00'
                            this.duration = '00:00:00'
                            this.voiceSrc = ''
                            this.voiceId = ''
                            this.audioPercent = '0%'
                            this.$refs.audioDom.src =  ''
                            this.$refs.audioDom.load()
                            this.showSuccess = true;
                        }
                    }
                })
            },
            bgToGif(index) {
                this.emojiList[index].showBg = this.emojiList[index].gif
            },
            gifToBg(index) {
                this.emojiList[index].showBg = this.emojiList[index].cover
            },
            getAnchorEmoji(id) {

                if(id){
                    this.anchorId = id;
                }
                
                const info = {
                    id: id || this.anchorId,
                    page: this.emojiIndex,
                    pagesize: 15
                }

                common.myFetch(config.apis.anchorMoves, info)
                .then((r) => {
                    if (r) {
                        console.log(r)
                        r.list.forEach(el => {
                            let second = el.value
                            second = second.replace(/\[/g,'')
                            second = second.replace(/\]/g,'')
                            // second = second.split(el.title)[1]
                            second = second.split('-')[1]
                            second = second.split('s')[0]
                            second = Number(second)
                            // console.log(second)
                            el.second = second
                            el.showBg = el.cover
                        })
                        this.emojiList = r.list;
                        this.emojiPage = r.page;
                    }
                })
            },
            composeAudio() {
                this.showLoading = true;
                let content = this.$refs.content.innerText
                this.emojiList.forEach(el => {
                    let value = el.value;
                    value = value.replace(/\[/g, '');
                    value = value.replace(/\]/g, '');
                    let second = el.second;
                    second = 'p'+second*1000;
                    // console.log(content,value)
                    // value = '[jiayou2-2.5s]'
                    content = content.replace(new RegExp(value,'g'),'')
                    content = content.replace('[]','')
                    // content = content.replace(new RegExp(value,'g'),second)
                })
                console.log(content)
                const info = {
                    title: 'HC'+Date.parse(new Date()),
                    content: content,
                    spd: this.speedList[this.speedIndex].spd,
                    vid: this.vid,
                    tab_key: this.tab_key
                }

                common.myFetch(config.apis.File_composite_callbackhd, info)
                .then((r) => {
                    if (r) {
                        // this.$toast(r)
                        // this.showLoading = false;
                        // this.loading = false;
                    }else{
                        this.showLoading = false;
                        this.loading = false;
                    }
                })
            },
            getWordList() {
                // console.log(this.testJson)
                let str = ''
                this.testJson.forEach((el,index) => {
                    str += `<span data-bg="${el.bg}">${el.word}</span>`
                })
                console.log(this.$refs.content)
                this.$refs.content.innerHTML = str;
                console.log(str)
            },
            getAnchorList() {
                let info = {}
                common.myFetch(config.apis.anchorList, info).then((r) => {
                    if (r) {
                        this.characterList = r.list
                        console.log(r)
                    }
                })
            },
            getAnchorDetail(id) {
                this.anchorId = id;
                let info = {
                    id: id
                }
                common.myFetch(config.apis.anchorDetail, info).then((r) => {
                    if (r) {
                        this.detail = r.detail;
                        this.bgUrl = r.detail.background;
                        this.characterUrl = r.detail.half;
                        // this.getWordList()
                    }
                })
            },
            
            getPlatformsVoices() {
                let info = {}
                common.myFetch(config.apis.platformsVoices, info).then((r) => {
                    if (r) {
                        console.log(r)
                        if(r.length > 0){
                           r.forEach(el => {
                            el.voiceIndex = 0
                            el.list.forEach(els => {
                                if(els.sex == '男'){
                                    els.sexSrc = this.boy
                                }else{
                                    els.sexSrc = this.girl
                                }
                            })
                           }) 

                           this.platformVoiceList = r

                            this.previewVoiceSrc = r[0].list[r[0].voiceIndex].preview_url
                            this.voiceName = r[0].list[r[0].voiceIndex].name
                            this.$refs.previewAudio.src = this.previewVoiceSrc
                            this.$refs.previewAudio.load()
                            this.voiceLanguage = r[0].list[r[0].voiceIndex].language
                            this.voiceSex = r[0].list[r[0].voiceIndex].sexSrc
                            this.vid = r[0].list[r[0].voiceIndex].id
                            this.tab_key = r[0].key
                        }
                    }
                })
            },
            getAnchorVoices() {
                let info = {}
                common.myFetch(config.apis.anchorVoices, info).then((r) => {
                    if (r) {
                        console.log(r)
                        r.list.forEach(el => {
                            if(el.sex == '男'){
                                el.sexSrc = this.boy
                            }else{
                                el.sexSrc = this.girl
                            }
                        })
                        this.voiceList = r.list
                        this.previewVoiceSrc = r.list[this.voiceIndex].preview_url
                        this.voiceName = r.list[this.voiceIndex].name
                        this.$refs.previewAudio.src = this.previewVoiceSrc
                        this.$refs.previewAudio.load()
                        this.voiceLanguage = r.list[this.voiceIndex].language
                        this.voiceSex = r.list[this.voiceIndex].sexSrc
                    }
                })
            },
            changeVoice() {
                this.voiceName = this.platformVoiceList[this.tabIndex].list[this.platformVoiceList[this.tabIndex].voiceIndex].name
                this.previewVoiceSrc = this.platformVoiceList[this.tabIndex].list[this.platformVoiceList[this.tabIndex].voiceIndex].preview_url
                this.$refs.previewAudio.src = this.previewVoiceSrc
                this.$refs.previewAudio.load()
                this.voiceLanguage = this.platformVoiceList[this.tabIndex].list[this.platformVoiceList[this.tabIndex].voiceIndex].language
                this.voiceSex = this.platformVoiceList[this.tabIndex].list[this.platformVoiceList[this.tabIndex].voiceIndex].sexSrc
                this.vid = this.platformVoiceList[this.tabIndex].list[this.platformVoiceList[this.tabIndex].voiceIndex].id
                this.tab_key = this.platformVoiceList[this.tabIndex].key
            },
            clickJump(e) {
                if(this.voiceSrc){
                    let clientX = this.$refs.line.getBoundingClientRect().x;
                    let width = this.$refs.progress.getBoundingClientRect().width;
                    let left = 0;
                    let percent = 0;

                    if(e.clientX - clientX <= 0){
                        left = '0%';
                        this.$refs.audioDom.currentTime = 0
                    }else if(e.clientX - clientX >= width){
                        left = '100%';
                        this.$refs.audioDom.currentTime = this.$refs.audioDom.duration
                    }else{
                        percent = (((e.clientX - clientX) / width) * 100).toFixed(2)
                        left = (((e.clientX - clientX) / width) * 100).toFixed(2) + '%'
                        this.$refs.audioDom.currentTime = this.$refs.audioDom.duration * ((e.clientX - clientX) / width)
                    }
                    console.log(percent,left)
                    this.audioPercent = left

                    console.log(e.clientX,clientX,width)
                }
            },
            changeBg(data) {
                const filelist = [];
                data.forEach(i => {
                    const type = 1;
                    // 将文件名改为截取前40位加后缀名
                    const fileName = i.pureName || i.title || i.filename || i.name || "";
                    const nameParts = fileName.split(".");
                    const ext = nameParts.pop();
                    let nameLeft = nameParts.join(".");
                    nameLeft = nameLeft.substr(0, 40);
                    const filetitle = `${nameLeft}.${ext}`;

                    const file = {
                        type: type,
                        title: filetitle,
                        path: i.targetPath || i.path
                    };

                    filelist.push(file);
                });

                const info = { file_info: JSON.stringify(filelist) };
                return common.myFetch(config.apis.File_add, info).then(r => {
                    if (r) {
                        console.log(r)
                        this.bgUrl = r.list[0].url
                    // this.getFileAssets();
                    }
                });
            },
            submit() {
                this.showMain = false;
                this.showSetting = true;
            },
            closeSpeed() {
                this.showSpeed = false;
            },
            closeStop() {
                this.showStop = false;
            },
            closeNum() {
                this.showNum = false;
            },
            closeEmoji() {
                this.showEmoji = false;
            },
            closeSb() {
                this.showSb = false;
            },
            setPause() {
                let sec = 0
                let sec1 = 0
                switch (this.stop) {
                    case 'p100':
                        sec = 0.1
                        sec1 = 100
                        break;
                    case 'p200':
                        sec = 0.2
                        sec1 = 200
                        break;
                    case 'p400':
                        sec = 0.4
                        sec1 = 400
                        break;
                    case 'p600':
                        sec = 0.6
                        sec1 = 600
                        break;
                    case 'p1000':
                        sec = 1.0
                        sec1 = 1000
                        break;
                    default:
                        break;
                }
                let content = `<span contenteditable="false" data-name="break" data-value="${Number(sec1)}ms" class="contentEditOn">停${sec}秒</span>`;
                this.showStop = false;
                this.$refs.content.focus();
                this.insertHtml(content)
                this.saveInnerHtmlContent = this.$refs.content.innerHTML
                // this.insertSpell1(content)
            },
            setNum() {
                // let date = new Date().getTime()
                let content = `<label class='on'>${this.saveStr}</label><span data-name="say-as" data-value="${this.num}" contenteditable="false" class="contentEditOn">${this.num == 'digits' ? '数字' : '数值' }</span>`;
                this.showNum = false;
                this.$refs.content.focus();
                this.insertHtml(content)
                this.saveInnerHtmlContent = this.$refs.content.innerHTML
            },
            delEmoji(e) {
                console.log(e.target.parentElement.parentNode)
                this.submitEmojiList = this.submitEmojiList.filter(el => {
                    return el.emojiIndex != e.target.dataset.index
                })

                console.log(this.submitEmojiList)

                e.target.parentElement.parentNode.remove()

                let span = document.querySelectorAll('#emojiContent span')
                for (let index = 0; index < span.length; index++) {
                    const element = span[index];
                    element.className = ''
                }

                this.submitEmojiList.forEach(el => {
                    for (let index = 0; index < span.length; index++) {
                        const element = span[index];
                        let bg = element.dataset.bg
                        if(el.bg == 0){
                            if(el.bg<=bg && el.ed>=bg){
                                element.className = 'on'
                            }
                        }else{
                            if(el.bg<bg && el.ed>=bg){
                                element.className = 'on'
                            }
                        }
                    }
                })


            },
            setDelClick() {
                let body = document.getElementsByTagName('body')[0].getBoundingClientRect().width
                let i = document.querySelectorAll('.contentEditLine p i')
                let p = document.querySelectorAll('.contentEditLine p')
                for (let index = 0; index < p.length; index++) {
                    const element = p[index];
                    if(body - element.getBoundingClientRect().left < 200){
                        element.style.left = 'unset'
                        element.style.right = 0
                    }
                    // console.log(body - element.getBoundingClientRect().left)
                }

                for (let index = 0; index < i.length; index++) {
                    const element = i[index];
                    element.removeEventListener('click',this.delEmoji)
                }

                for (let index = 0; index < i.length; index++) {
                    const element = i[index];
                    element.addEventListener('click',this.delEmoji)
                }
            },
            setEmoji(emoji,index) {
                console.log(emoji)
                this.emojiStatusIndex++
                let content = `<div contenteditable="false" data-sec="${emoji.second}" class="contentEditLine"><p>${emoji.title}<i data-index="${this.emojiStatusIndex}"></i></p></div>`;
                this.emojiList[index].showBg = this.emojiList[index].cover
                this.showEmoji = false;
                this.$refs.content3.focus();
                this.insertHtmlandSetArr(content,emoji.second,emoji.key,this.emojiStatusIndex)
                this.setDelClick()
                let span = document.querySelectorAll('#emojiContent span')
                for (let index = 0; index < span.length; index++) {
                    const element = span[index];
                    element.className = ''
                }

                this.submitEmojiList.forEach(el => {
                    for (let index = 0; index < span.length; index++) {
                        const element = span[index];
                        let bg = element.dataset.bg
                        if(el.bg == 0){
                            if(el.bg<=bg && el.ed>=bg){
                                element.className = 'on'
                            }
                        }else{
                            if(el.bg<bg && el.ed>=bg){
                                element.className = 'on'
                            }
                        }
                    }
                })

                this.saveContent3 = this.$refs.content3.innerHTML
            },
            backIndex() {
                common.jump("/index", false);
            },
            async backSelect() {
                if(!this.showMain && !this.showSetting){
                    let status = true
                    let msg = `将要返回首页，是否继续？`;
                    status = await this.$confirm(msg);
                    if(!status) return
                    common.jump("/index", false);
                }else if(this.stepNum == 1){
                    // let status = true
                    // let msg = `将要返回上一步，是否继续？`;
                    // status = await this.$confirm(msg);
                    // if(!status) return
                    this.pendingNext = true;
                    if(this.showUploadFile || this.showWrite){
                        this.$refs.content.innerText = '';
                        this.showUploadFile = false;
                        this.showWrite = false;
                        this.showSelect = true;
                    }else{
                        let status = true
                        let msg = `将要返回上一步，是否继续？`;
                        status = await this.$confirm(msg);
                        if(!status) return
                        this.stepNum = 0;
                        this.showMain = false;
                    }
                }else if(this.stepNum == 2){
                    // let status = true
                    // let msg = `将要返回上一步，是否继续？`;
                    // status = await this.$confirm(msg);
                    // if(!status) return
                    if(this.$refs.audioDom){
                        this.$refs.audioDom.pause()
                    }
                    this.stepNum = 1
                }else if(this.stepNum == 3 && this.showSetting && !this.showSuccess){
                    // let status = true
                    // let msg = `将要返回上一步，是否继续？`;
                    // status = await this.$confirm(msg);
                    // if(!status) return
                    this.showSetting = false;
                    this.stepNum = 2
                }else{
                    this.$refs.content.innerHTML = ''
                    this.$refs.content3.innerHTML = ''
                    this.speedIndex = 2;
                    this.speed = '1.0';
                    this.saveContent = '';
                    this.saveContent3 = '';
                    this.saveVoiceIndex = 0;
                    this.voiceId = '';
                    this.posIndex = 0;
                    this.cameraIndex = 0;
                    this.showSetting = false;
                    this.showSuccess = false;
                    this.loading = false;
                    this.isPlay = false;
                    this.showLoading = false;
                    this.showMain = false;
                    this.showWrite = false;
                    this.showUploadFile = false;
                    this.pendingNext = true;
                    this.showPlaceHolder = true;
                    this.stepNum = 0;
                    this.submitEmojiList = [];
                    this.tab_key = this.platformVoiceList[0].key
                    this.vid = this.platformVoiceList[0].list[0].id
                    this.voiceName = this.platformVoiceList[0].list[0].name
                    this.voiceLanguage = this.platformVoiceList[0].list[0].language
                    this.voiceSex = this.platformVoiceList[0].list[0].sexSrc
                    this.previewVoiceSrc = this.platformVoiceList[0].list[0].preview_url
                    this.voiceIndex = 0
                    this.wordNum = 1500
                    this.titleInput = ''
                    this.beginInput = 0
                    this.overInput = 0
                    this.hdIndex = 0
                    this.platformVoiceList.forEach(el => {
                        el.voiceIndex = 0
                    })
                }
            },
            beginUp() {
                if(this.beginInput>=0){
                    this.beginInput++
                }
            },
            beginDown() {
                if(this.beginInput>=1){
                    this.beginInput--
                }
            },
            overUp() {
                if(this.overInput>=0){
                    this.overInput++
                }
            },
            overDown() {
                if(this.overInput>=1){
                    this.overInput--
                }
            },
            async showMaterialListBox() {
                // this.$refs.mediaCenter.showMaterialListBox1('myMaterial', false).then(res => {
                //     this.cover = res;
                //     this.hasCover = true;
                // })
                let id = '';
                let config = {
                    subject_id: id, //文稿的id
                    subject_type: '',
                    quickEdit: '',
                    create: '',
                    d: '',
                    materialChannel: 'myMaterial',
                    showMore: false,
                    showBg: true,
                    isAnchor: true
                };
                console.log(config)
                this.$materialListBox(config).then(res => {
                    if (res) {
                        this.bgUrl = res
                        console.log(res)
                    }
                });
            },
            spellConfirm() {
                // if(!this.spellInput) return
                // let spell = 1;
                // if (this.sb == '第一声') {
                //     spell = 1;
                // } else if (this.sb == '第二声') {
                //     spell = 2;
                // } else if (this.sb == '第三声') {
                //     spell = 3;
                // } else if (this.sb == '第四声') {
                //     spell = 4;
                // }

                if(!this.canConfirm) return

                let canSubmit = true;
                let str = ''
                let str1 = ''
                let arr = []
                this.textArr.forEach(el => {
                    if(!el.value){
                        canSubmit = false;
                    }else{
                        let spell = 1;
                        if (el.voiceName == '第一声') {
                            spell = 1;
                        } else if (el.voiceName == '第二声') {
                            spell = 2;
                        } else if (el.voiceName == '第三声') {
                            spell = 3;
                        } else if (el.voiceName == '第四声') {
                            spell = 4;
                        }
                        arr.push(el.value + spell)
                    }
                })

                if(!canSubmit) return

                str = arr.join(',')

                str1 = arr.join(' ')

                let content = `<label class='on'>${this.saveStr}</label><span data-name="phoneme" data-value="${str1}" contenteditable="false" class="contentEditOn">${str}</span>`;

                // let content = `<span contenteditable="false" data-name="[=${this.spellInput}${spell}]" class="contentEditOn">音${this.spellInput}${spell}</span>`;
                this.showWord = false;
                this.spellInput = ''
                this.sb = '第一声'
                this.spell = 1
                this.insertSpell1(content)
            },
            insertHtml(html) {
                var sel, range, frag
                if (window.getSelection) {
                    sel = window.getSelection()
                    if (sel.getRangeAt && sel.rangeCount) {
                        range = sel.getRangeAt(0)
                        range.deleteContents()
                        var el = document.createElement('div')
                        el.innerHTML = html
                        frag = document.createDocumentFragment()
                        var node
                        var lastNode
                        while ((node = el.firstChild)) {
                            lastNode = frag.appendChild(node)
                        } range.insertNode(frag)
                        if (lastNode) {
                            range = range.cloneRange()
                            range.setStartAfter(lastNode)
                            range.collapse(true)
                            sel.removeAllRanges()
                            sel.addRange(range)
                            console.log(sel)
                        }
                    }
                }
            },
            insertHtmlandSetArr(html,second,id,emojiIndex) {
                let status = true
                var sel, range, frag
                if (window.getSelection) {
                    sel = window.getSelection()
                    // console.log(sel.getRangeAt)
                    // return false;
                    if (sel.getRangeAt && sel.rangeCount) {
                        range = sel.getRangeAt(0)
                        range.deleteContents()
                        console.log(range)
                        let bg = 0;
                        if(range.commonAncestorContainer.parentNode.dataset.bg){
                            bg = Number(range.commonAncestorContainer.parentNode.dataset.bg)
                        }
                        let ed = bg + Number(second) * 1000
                        if(this.submitEmojiList.length > 0){
                            this.submitEmojiList.forEach(el => {
                                console.log(el,bg,ed)
                                if((el.bg <= bg && el.ed >= bg) || (el.bg <= ed && el.ed >= ed)){
                                    this.showTips = true
                                    status = false
                                }
                            })
                        }

                        if(status){
                            this.submitEmojiList.push({
                                bg: bg,
                                ed: ed,
                                id: id,
                                emojiIndex: emojiIndex
                            })

                            console.log(this.submitEmojiList)

                            var el = document.createElement('div')
                            el.innerHTML = html
                            frag = document.createDocumentFragment()
                            var node
                            var lastNode
                            while ((node = el.firstChild)) {
                                lastNode = frag.appendChild(node)
                            } range.insertNode(frag)
                            if (lastNode) {
                                range = range.cloneRange()
                                range.setStartAfter(lastNode)
                                range.collapse(true)                       
                                sel.removeAllRanges() 
                                sel.addRange(range)                           
                            }
                        }
                    }
                }
            },
            setStatus(index) {
                let wordInputContainer = document.getElementsByClassName('wordInput-container')[0].getBoundingClientRect().top;
                let li = document.querySelectorAll('.wordInput-container .input-container .input')[index].getBoundingClientRect().top
                this.top = li - wordInputContainer + 42
                this.textArr.forEach((item,i) => {
                    if(index == i){
                        if(item.status){
                            item.status = false
                        }else{
                            item.status = true
                        }
                    }else{
                        item.status = false
                    }
                })
            },
            insertNum() {
                // var sel, range, frag
                if (window.getSelection) {
                    this.sel = window.getSelection()
                    let str = this.sel
                    str = str.toString()
                    if(str.length > 0){
                        if (this.sel.getRangeAt && this.sel.rangeCount) {
                            this.range = this.sel.getRangeAt(0)
                            // console.log(this.range)
                            // let str = this.range.commonAncestorContainer.textContent.slice(this.range.startOffset, this.range.endOffset)
                            this.saveStr = str;
                            this.frag = document.createDocumentFragment()
                            this.showNum = !this.showNum
                        }
                    }else{
                        this.$MediaPlatformNotifyAuth({
                            title: '温馨提示',
                            msg: '您尚未选中任何文字!',
                            btn1: '取消',
                            btn2: '',
                            showIcon: false
                        })
                    }
                    // console.log(this.sel.toString())
                }
            },
            insertSpell() {
                // var sel, range, frag
                if (window.getSelection) {
                    this.sel = window.getSelection()
                    let str = this.sel
                    str = str.toString()
                    if(str.length > 0){
                        if (this.sel.getRangeAt && this.sel.rangeCount) {
                            this.range = this.sel.getRangeAt(0)
                            this.saveStr = str;
                            this.textArr = [];
                            let textArr = str.split('')
                            textArr.forEach(el => {
                                this.textArr.push({
                                    name: el,
                                    value: '',
                                    voiceIndex: 0,
                                    voiceName: '第一声',
                                    status: false
                                })
                            })
                            // var el = document.createElement('div')
                            // el.innerHTML = html
                            this.frag = document.createDocumentFragment()
                            this.showWord = !this.showWord
                            // var node
                            // var lastNode
                            // while ((node = el.firstChild)) {
                            //     lastNode = frag.appendChild(node)
                            // } range.insertNode(frag)
                            // if (lastNode) {
                            //     range = range.cloneRange()
                            //     range.setStartAfter(lastNode)
                            //     range.collapse(true)
                            //     sel.removeAllRanges()
                            //     sel.addRange(range)
                            // }
                        }
                    }else{
                        this.$MediaPlatformNotifyAuth({
                            title: '温馨提示',
                            msg: '您尚未选中任何文字!',
                            btn1: '取消',
                            btn2: '',
                            showIcon: false
                        })
                    }
                    
                }
            },
            insertSpell1(html) {
                this.range.deleteContents()
                var el = document.createElement('div')
                el.innerHTML = html
                var node
                var lastNode
                while ((node = el.firstChild)) {
                    lastNode = this.frag.appendChild(node)
                } 
                this.range.insertNode(this.frag)
                if (lastNode) {
                    this.range = this.range.cloneRange()
                    this.range.setStartAfter(lastNode)
                    this.range.collapse(true)
                    this.sel.removeAllRanges()
                    this.sel.addRange(this.range)
                }

                this.range = '';
                this.sel = '';
                this.frag = '';
            },
            configUpload() {
                // 配置上传接口
                Promise.all([this.load(), this.getConfig(), this.getAsperaConfig()]).then(() => {
                    this.picStream = new Stream(this.picConfig)
                })
            },
            checkSrc() {
                this.loading = false;
                this.isPlay = true;
                this.$refs.audioDom.play()
                // if(this.voiceSrc && this.saveContent == this.$refs.content.innerText && this.saveVoiceIndex == this.voiceIndex){
                //     // this.$refs.audioDom.src = this.voiceSrc;
                //     // this.$refs.audioDom.load()
                //     this.loading = false;
                //     this.isPlay = true;
                //     this.$refs.audioDom.play()
                // }else{
                //     if(this.$refs.content.innerText){
                //         this.loading = true;
                //         this.composeAudio()
                //     }else{
                //         this.$toast('文本内容不能为空')
                //     }
                // }
            },
            s2hms(time) {
                var min = Math.floor(time % 3600);
                var hh =
                    Math.floor(time / 3600) < 10
                    ? "0" + Math.floor(time / 3600)
                    : Math.floor(time / 3600);
                var mm =
                    Math.floor(min / 60) < 10
                    ? "0" + Math.floor(min / 60)
                    : Math.floor(min / 60);
                var ss = time % 60 < 10 ? "0" + parseInt(time % 60) : parseInt(time % 60);
                return hh + ":" + mm + ":" + ss;
                // console.log(hh + ":" + mm + ":"+ ss)
            },
            pause() {
                this.$refs.audioDom.pause()
            },
            step2Detail(id) {
                let info = {
                    file_id: id
                }
                common.myFetch(config.apis.anchorAudioDetail, info).then((r) => {
                    if (r) {
                        console.log(r)
                        let str = ''
                        r.pickRes.forEach(el => {
                            str += `<span data-bg="${el.bg}">${el.word}</span>`
                        })
                        this.$refs.content3.innerHTML = str
                        this.saveContent3 = str
                        this.$refs.audioDom.src =  r.url
                        this.$refs.audioDom.load()
                        this.voiceSrc = r.url
                    }
                })
            },
            setSrc(e) {
                console.log(e,this.loading)
                if(this.loading && this.anchor_id == e.content.content.anchor_id){
                    console.log(e)
                    let id = e.content.content.id;
                    this.step2Detail(id)
                    this.$toast('语音合成成功')
                    this.showLoading = false;
                    // this.$refs.audioDom.src =  e.content.url
                    // this.$refs.audioDom.load()
                    // this.voiceSrc = e.content.url
                    // this.voiceId = e.content.id
                    this.loading = false;
                    // this.saveContent = this.$refs.content.innerText;
                    // this.saveVoiceIndex = this.voiceIndex;
                }
            },
            caculatePos() {
                if(document.body.clientWidth <= 1600){
                    this.posRight = true
                }else{
                    this.posRight = false
                }
            },
            recalc() {
                var clientWidth = document.documentElement.clientWidth;

                if (!clientWidth) {

                    return;
                }

                var p = 100 * (clientWidth / 1334);

                this.fontSizeWrite = p

                if(p<97.3){
                    p=97.3
                }else if(p>110){
                    p=110
                }

                this.fontSize = p
            }   
        },
        mounted() {
            let that = this;
            let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

            window.addEventListener(resizeEvt, this.recalc, false);

            this.recalc()

            // if(this.$refs.content){
            //     this.$refs.content.addEventListener('focus', () => {
            //         this.showPlaceHolder = false
            //     })
            //     this.$refs.content.addEventListener('blur', () => {
            //         if(!this.$refs.content.innerText){
            //             this.showPlaceHolder = true
            //         }   
            //     })
            // }

            // this.$refs.content.addEventListener("input", (e) => {
            //     console.log(e)
            //     if(e.target.innerText.length > 0){
            //         this.pendingNext = false;
            //     }else{
            //         this.pendingNext = true;
            //     }
            // });

            this.$refs.audioDom.addEventListener('canplay', () => {
                let duration = this.$refs.audioDom.duration;
                if(isNaN(duration)){
                    this.duration = '00:00:00'
                }else{
                    this.duration = this.s2hms(parseInt(duration));
                }
            })

            this.$refs.audioDom.onplay = function(e) {
                
            }

            this.$refs.audioDom.onpause = function(e) {

            }

            this.$refs.audioDom.onended = function(e) {
                that.isPlay = false;
            }

            this.$refs.audioDom.ontimeupdate = function(e) {
                // console.log(e.target.currentTime,this.s2hms)
                that.currentTime = that.s2hms(parseInt(e.target.currentTime));
                let percent =
                (
                    (parseInt(e.target.currentTime) / parseInt(e.target.duration)) *
                    100
                ).toFixed(2) + "%";
                that.audioPercent = percent;
            }
            this.$refs.audioDom.src = this.voiceSrc;
            this.$refs.audioDom.load()

            window.addEventListener('resize', (e) => {
                this.caculatePos()
            })

            this.caculatePos()
            common.handleSocket(this.setSrc, "makeupaudio");
            common.handleSocket(this.setSrc, "pickuptext");
        },
        created() {
            this.loadConfig().then(() => {
                console.log('success')
                this.setConfig()
            })
            this.getAnchorList()
            // this.getAnchorVoices()   
            this.getPlatformsVoices()
            // this.getWordList()
        }
    }
</script>

<style src="@assets/css/anchor/anchor.less" lang="less" scoped></style>
<style lang="less">
    // .contentEditOnContainer {
    //     span {
    //         &:nth-last-of-type(2) {
    //             color: #41B48C;
    //         }
    //     }
    // }
    .write-container .writeContent {
        span {
            display: inline-flex;
            min-width: 2px;
            // line-height: 19px;
            min-height: 19px;
        }
    }
    .contentEditOn {
        display: inline-block;
        color: #41B48C;
        height: 24px;
        font-size: 13px;
        font-weight: normal;
        line-height: 24px;
        padding: 0 10px;
        box-sizing: border-box;
        background: #E6F1ED;
        border-radius: 4px;
        border: 1px solid #41B48C;
        box-sizing: border-box;
        margin: 0 3px;
    }

    .writeContent label.on {
        color: #41B48C;
    }

    .contentEditLine {
        display: inline-block;
        position: relative;
        width: 1px;
        height: 46px;
        background: #41B48C;

        &:hover {
            p {
                background: #41B48C;
                color: #FFF;

                i {
                    display: block;
                }
            }
        }
        
        p {
            display: flex;
            flex-direction: row;
            align-items: center;
            position: absolute;
            top: 0;
            left: 0;
            min-width: max-content;
            height: 24px;
            line-height: 24px;
            padding: 0 10px;
            box-sizing: border-box;
            border: 1px solid #41B48C;
            background: #E6F1ED;
            border-radius: 4px 4px 4px 0px;
            font-size: 13px;
            color: #41B48C;

            i {
                display: none;
                width: 12px;
                height: 12px;
                background: url('../../assets/img/anchor/close.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                user-select: none;
                cursor: pointer;
                margin-left: 9px;
            }
        }
    }

    #emojiContent {
        span {
            &.on {
                color: #41B48C;
            }
        }
    }
</style>